import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { useToast } from '../hooks/use-toast';
import { Download, MapPin } from 'lucide-react';

const MapsPage = () => {
  const { toast } = useToast();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });

  // PDF data
  const pdfMaps = [
    {
      id: 1,
      title: 'Sector 25 - 7% Maps',
      description: 'Detailed sector maps for 7% Kisan Aabadi plots',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/zub9ulyi_SECTOR-25-7%25.pdf',
      filename: 'SECTOR-25-7%.pdf'
    },
    {
      id: 2,
      title: 'Yamuna Authority Maps',
      description: 'Official Yamuna Expressway Authority layout maps',
      location: "Yamuna Expressway",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/mvo586qe_yamuna%20Authority%20maps.pdf',
      filename: 'yamuna-authority-maps.pdf'
    },
    {
      id: 3,
      title: 'PLU Master Plan',
      description: 'Master plan for PLU development area',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/wbk8o3d9_O3_PLU_Master10.pdf',
      filename: 'O3_PLU_Master10.pdf'
    },
    {
      id: 4,
      title: 'Sector 33 Maps',
      description: 'Comprehensive sector 33 layout and plot details',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/wwaxme86_mapsec33%20%281%29.pdf',
      filename: 'mapsec33.pdf'
    },
    {
      id: 5,
      title: 'Sector 32 Maps',
      description: 'Detailed sector 32 area maps and plot information',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/3lo7jacn_mapsec32.pdf',
      filename: 'mapsec32.pdf'
    },
    {
      id: 6,
      title: 'O3 PLU Master Plan (Updated)',
      description: 'Updated PLU master development plan with latest revisions',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/wi7gakwm_O3_PLU_Master10%20%281%29.pdf',
      filename: 'O3_PLU_Master10_Updated.pdf'
    },
    {
      id: 7,
      title: 'Sector 17A Maps',
      description: 'Complete sector 17A layout plans and plot allocation',
      location: "Greater Noida West",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/cw9t2d6d_SEC-17A.pdf',
      filename: 'SEC-17A.pdf'
    },
    {
      id: 8,
      title: 'Sector 16 Maps',
      description: 'Detailed sector 16 area maps and development plans',
      location: "Greater Noida West",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/v7xlq1n8_SEC-16-.pdf',
      filename: 'SEC-16.pdf'
    },
    {
      id: 9,
      title: 'Sector 24 Maps',
      description: 'Sector 24 comprehensive layout and plot information',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/1vzs7r47_Sec-24.pdf',
      filename: 'Sec-24.pdf'
    },
    {
      id: 10,
      title: 'Sector 18 & 20 Maps',
      description: 'Combined sector 18 and 20 detailed layout plans (Version 4.0)',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/jmxrqo7i_Map%20-%20Sector%2018%20%26%2020%20%28Ver%204.0%29%20Watermark.pdf',
      filename: 'Map-Sector-18-20-Ver4.0.pdf'
    },
    {
      id: 11,
      title: 'Achega Sector Maps',
      description: 'Achega sector comprehensive layout and development plans',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/r0yhnnjd_achega.pdf',
      filename: 'achega.pdf'
    },
    {
      id: 12,
      title: 'Ronija Sector 22E Maps',
      description: 'Ronija sector 22E detailed plot allocation and layout plans',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/yy7j2c2i_Ronija%20SEC-22E.pdf',
      filename: 'Ronija-SEC-22E.pdf'
    },
    {
      id: 13,
      title: 'Sector 17A Maps (Revised)',
      description: 'Revised sector 17A layout plans with updated plot details',
      location: "Greater Noida West",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/6lqa9cjq_SEC-17A%20%281%29.pdf',
      filename: 'SEC-17A-Revised.pdf'
    },
    {
      id: 14,
      title: 'O3 PLU Master Plan (Latest)',
      description: 'Latest version of PLU master plan with all recent updates',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/ryw0y0qz_O3_PLU_Master10%20%282%29.pdf',
      filename: 'O3_PLU_Master10_Latest.pdf'
    },
    {
      id: 15,
      title: 'Sector 24 Maps (Updated)',
      description: 'Updated sector 24 comprehensive layout with revised plot information',
      location: "Greater Noida",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/lxy4nevc_Sec-24%20%281%29.pdf',
      filename: 'Sec-24-Updated.pdf'
    },
    {
      id: 16,
      title: 'Yamuna Expressway Maps',
      description: 'Comprehensive Yamuna Expressway area development maps and layout plans',
      location: "Yamuna Expressway",
      url: 'https://customer-assets.emergentagent.com/job_built-properties/artifacts/ovn9lf02_yamuna.pdf',
      filename: 'yamuna.pdf'
    }
  ];

  const handleDownloadClick = (pdf) => {
    setSelectedPdf(pdf);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedPdf(null);
    setFormData({ name: '', phone: '', email: '' });
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate all fields are filled
    if (!formData.name.trim() || !formData.phone.trim() || !formData.email.trim()) {
      toast({
        title: "All fields required",
        description: "Please fill in all the fields to download the map.",
        variant: "destructive"
      });
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast({
        title: "Invalid email",
        description: "Please enter a valid email address.",
        variant: "destructive"
      });
      return;
    }

    // Validate phone number (10 digits)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.phone.replace(/\s/g, ''))) {
      toast({
        title: "Invalid phone number",
        description: "Please enter a valid 10-digit phone number.",
        variant: "destructive"
      });
      return;
    }

    try {
      // Create download URL using backend proxy
      const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/api/download-pdf?url=${encodeURIComponent(selectedPdf.url)}&filename=${encodeURIComponent(selectedPdf.filename)}`;
      
      // For iOS: Open download in new window BEFORE async operation
      // This must be synchronous to avoid popup blocker
      const downloadWindow = window.open(downloadUrl, '_blank');
      
      // Submit lead data to backend (async, after window.open)
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/leads`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: formData.name,
            phone: formData.phone,
            email: formData.email,
            pdf_name: selectedPdf.filename
          })
        });

        if (!response.ok) {
          console.warn('Lead submission failed, but download started');
        }
      } catch (emailError) {
        console.warn('Email notification failed:', emailError);
        // Don't stop download if email fails
      }

      // Show success message
      toast({
        title: "Download started",
        description: `Thank you ${formData.name}! Your map is downloading now.`,
      });

      // Close dialog and reset form
      handleCloseDialog();
      
    } catch (error) {
      console.error('Error:', error);
      toast({
        title: "Download failed",
        description: "There was an error. Please try again or contact support.",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative h-[400px] bg-gradient-to-r from-gray-900 to-gray-800 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=2000')",
          }}
        ></div>
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Property Maps & Plans
          </h1>
          <p className="text-xl text-white/90">
            Download detailed maps and layout plans for various sectors
          </p>
        </div>
      </section>

      {/* Maps Grid Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Available Property Maps
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Access comprehensive property maps for informed decision making
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {pdfMaps.map((pdf) => (
              <div 
                key={pdf.id} 
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#B8944A]"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="bg-amber-100 p-3 rounded-lg">
                    <MapPin className="text-[#B8944A]" size={24} />
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {pdf.title}
                </h3>
                
                <p className="text-sm text-gray-600 mb-2 flex items-center">
                  <MapPin size={14} className="mr-1" />
                  {pdf.location}
                </p>
                
                {pdf.description && (
                  <p className="text-xs text-gray-500 mb-4 line-clamp-2">
                    {pdf.description}
                  </p>
                )}
                
                <Button 
                  onClick={() => handleDownloadClick(pdf)}
                  className="w-full bg-[#B8944A] hover:bg-[#A07D3A] text-white"
                >
                  <Download className="mr-2" size={18} />
                  Download Map
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Download Dialog */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-2xl">Download Property Map</DialogTitle>
            <DialogDescription className="text-base">
              Please provide your details to download <strong>{selectedPdf?.title}</strong>
            </DialogDescription>
          </DialogHeader>
          
          <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            <div>
              <Input
                type="text"
                name="name"
                placeholder="Full Name *"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="w-full"
              />
            </div>
            
            <div>
              <Input
                type="tel"
                name="phone"
                placeholder="Phone Number (10 digits) *"
                value={formData.phone}
                onChange={handleInputChange}
                required
                maxLength="10"
                className="w-full"
              />
            </div>
            
            <div>
              <Input
                type="email"
                name="email"
                placeholder="Email Address *"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="w-full"
              />
            </div>
            
            <div className="flex gap-3 pt-4">
              <Button 
                type="button" 
                variant="outline" 
                onClick={handleCloseDialog}
                className="flex-1"
              >
                Cancel
              </Button>
              <Button 
                type="submit" 
                className="flex-1 bg-[#B8944A] hover:bg-[#A07D3A]"
              >
                <Download className="mr-2" size={18} />
                Download
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MapsPage;
